
const $ = require('jquery');


module.exports = function fadeIn () {
	const content = $('#MyContent');
	content.css('visibility', 'visible').fadeOut(0).fadeIn(100);
};

